import ServerMaintenance from '@/components/ServerMaintenance'
import { CreatePasswordForm } from '@/pages/login/CreatePasswordForm'
import { LoginForm } from '@/pages/login/LoginForm'
import { ResetPasswordForm } from '@/pages/login/ResetPasswordForm'
import { SignUpForm } from '@/pages/login/SignUpForm'
import { ConfigProvider, Flex } from 'antd'
import { loginApi } from 'common/api/entitiesApi'
import { useUserContext } from 'common/context/UserContext'
import { buildThemeFromPalette } from 'common/util/colorPalette.ts'
import { isAuthenticated, setLoggedUserProps } from 'common/util/Util.tsx'
import * as React from 'react'
import { useEffect, useMemo, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import 'common/pages/style.css'

import { AppAdvertiser } from './AppAdvertiser.tsx'
import * as routes from './routes'
import { CommonRoutes } from 'common/context/commonRoutes.ts'

export const Main: React.FC = () => {
  const location = useLocation()
  const { setUser, colorPalette, customizationLoaded } = useUserContext()
  const navigateTo = useNavigate()
  const [appReady, setAppReady] = useState(false)

  useEffect(() => {
    let isMounted = true

    const init = async () => {
      const urlParams = new URLSearchParams(location.search)
      const tokenParam = urlParams.get('token')
      if (tokenParam) {
        const success = await loginApi.loginByToken(tokenParam)
        if (success) {
          await setLoggedUserProps(setUser)
        }
        navigateTo('/', { replace: true })
      } else if (isAuthenticated()) {
        await setLoggedUserProps(setUser)
      }

      if (isMounted) {
        setAppReady(true)
      }
    }

    init()

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  const theme = useMemo(() => buildThemeFromPalette(colorPalette), [colorPalette])

  if (!customizationLoaded || !appReady) {
    return (
      <Flex
        justify="center"
        align="center"
        style={{ minHeight: '100vh', backgroundColor: colorPalette['--color-grey-4'] }}
      />
    )
  }

  return (
    <ConfigProvider theme={theme}>
      <Flex
        justify="center"
        align="center"
        style={{ minHeight: '100vh', backgroundColor: colorPalette['--color-grey-4'] }}
      >
        <Routes>
          <Route path={CommonRoutes.LOGIN} element={<LoginForm />} />
          <Route path={routes.MAINTENANCE} element={<ServerMaintenance />} />
          <Route path={routes.SIGN_UP_ADVERTISER} element={<SignUpForm />} />
          <Route path={routes.SIGN_UP_PASSWORD} element={<CreatePasswordForm title="Sign Up" />} />
          <Route path={routes.SIGN_UP_PASSWORD_TAIL} element={<CreatePasswordForm title="Sign Up" />} />
          <Route path={routes.NEW_PASSWORD} element={<CreatePasswordForm title="Reset Password" />} />
          <Route path={routes.NEW_PASSWORD_TAIL} element={<CreatePasswordForm title="Reset Password" />} />
          <Route path={routes.RESET_PASSWORD} element={<ResetPasswordForm />} />
          <Route path="*" element={<AppAdvertiser />} />
        </Routes>
      </Flex>
    </ConfigProvider>
  )
}
